// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

import { TableCellLayout } from '@fluentui/react-components';
import { CoursePlatform } from '@microsoft/vscodeedu-api';
import React from 'react';
import { CoursePlatformText } from '../common';

// Curriculum platform cell properties.
export type PlatformCellProps = Readonly<{
    value: CoursePlatform;
}>;

// Curriculum platform data grid cell contents.
export default (props: PlatformCellProps) => {
    const { value } = props;
    return (
        <TableCellLayout>
            <CoursePlatformText value={value} />
        </TableCellLayout>
    );
};
